import { render } from "./Bubble.vue?vue&type=template&id=78e2e289&scoped=true"
import script from "./Bubble.vue?vue&type=script&lang=js"
export * from "./Bubble.vue?vue&type=script&lang=js"

import "./Bubble.vue?vue&type=style&index=0&id=78e2e289&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e2e289"]])

export default __exports__